/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.Vue = require("vue");
const Dropzone = require("dropzone");
window.Dropzone = Dropzone.default || Dropzone;
window.Dropzone.autoDiscover = false;

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueApexCharts from "vue-apexcharts";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue/dist/bootstrap-vue.css";

import Vuelidate from "vuelidate";

import Popover from "vue2-popover";

Vue.use(Popover);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueApexCharts);
Vue.use(DatePicker);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);

Vue.component("apexchart", VueApexCharts);
Vue.component("date-picker", DatePicker);

import Dashboard from "./vue/components/Dashboard/DashboardComponent";
import Conversaciones from "./vue/components/reportes/conversaciones/Index";
import Facturacion from "./vue/components/reportes/facturacion/index";
import Audios from "./vue/components/reportes/audios/index_campana";
import AudiosLlamadasOut from "./vue/components/reportes/audios/index_llamadas_out";
import FAQ from "./vue/components/reportes/preguntas_frecuentes/index.vue";
import BotonesCampanas from "./vue/components/reportes/botones_campanas/index.vue";
import LlamadaSeguimiento from "./vue/components/reportes/llamada_seguimiento/index.vue";
import EncuestaWatson from "./vue/components/reportes/encuesta-watson/index.vue";
import DashboardDinamic from "./vue/Views/DashboardDinamicComponent.vue";
import DashboardReportNMV from "./vue/components/DashboardReportNMV/index.vue";

// import DashboardReportNMV from './vue/Views/DasboardReportNMV.vue'
import ReporteDetalle from "./vue/components/reportes/reporte_detalles/index.vue";
import InteraccionSinWatson from "./vue/components/reportes/interaccion_sin_watson/index";
import ServiciosViceBida from "./vue/components/reportes/servicios_bicevida/index";
import Agenda from "./vue/components/Agendas/index";

Vue.component("dashboard", Dashboard);
Vue.component("reporte-conversaciones", Conversaciones);
Vue.component("reporte-facturacion", Facturacion);
Vue.component("reporte-audios-camapana", Audios);
Vue.component("reporte-audios-llamadas-out", AudiosLlamadasOut);
Vue.component("reportes-faq", FAQ);
Vue.component("botones-campanas", BotonesCampanas);
Vue.component("llamada-seguimiento", LlamadaSeguimiento);
Vue.component("encuesta-watson", EncuestaWatson);
Vue.component("dashboard-dinamic", DashboardDinamic);
Vue.component("dashboard-report-nmv", DashboardReportNMV);
Vue.component("reporte-detalle", ReporteDetalle);
Vue.component("interaccion-sin-watson", InteraccionSinWatson);
Vue.component("servicios-bicevida", ServiciosViceBida);
Vue.component("agenda", Agenda);

import EditarTipoCita from "./vue/components/Subconjuntos/EditarTipoCita";
import EditarEspecialidad from "./vue/components/Subconjuntos/EditarEspecialidad";
import EditarServicios from "./vue/components/Subconjuntos/EditarServicios";

Vue.component("editarcita", EditarTipoCita);
Vue.component("editarEspecialidad", EditarEspecialidad);
Vue.component("editarServicios", EditarServicios);

import Erroresintegraciones from "./vue/components/reportes/Erroresintegraciones/index";
import ErroresintegracionesDetalles from "./vue/components/reportes/Erroresintegraciones/detalles";

Vue.component("erroresIntegraciones", Erroresintegraciones);
Vue.component("erroresIntegracionesDetalles", ErroresintegracionesDetalles);

import ListaNegra from "./vue/components/Configuraciones/ListaNegra/Index";
Vue.component("lista-negra", ListaNegra);

import TwoFact from "./vue/components/Perfil/two_factor";
Vue.component("two-fact", TwoFact);

import TwoFactor from "./vue/components/TwoFactor/index";
Vue.component("two-factor", TwoFactor);

import Pruebas from "./vue/components/Pruebas/index";
Vue.component("pruebas", Pruebas);

import Horas from "./vue/components/Configuraciones/Horas/index.vue";
Vue.component("horas", Horas);

import Discord from "./vue/components/Configuraciones/Discord/index.vue";
Vue.component("discord", Discord);

import { numberFormat } from "./vue/store/filters";
Vue.filter("numberFormat", numberFormat);

import HomeWidgets from "./vue/components/Home/LayoutWidgets.vue";
Vue.component("home-widgets", HomeWidgets);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// if (document.getElementById('app') != null) {
//     const app = new Vue({
//         el: '#app'
//     });
// }

// if (document.getElementById('reportes') != null) {
//     const app = new Vue({
//         el: '#reportes'
//     });
// }

import store from "./vue/store";
import Main from "./vue/Views/MainComponent";
import Vue from "vue";
import "vue-good-table/dist/vue-good-table.css";

const app = new Vue({
    el: "#app",
    component: { Main },
    store,
});
